module.exports = __webpack_public_path__ + "img/bonaire.630eefd4.svg";